import { useCurrentPath } from '@/features/search/hooks/use-current-path'

import { useHeaderSearch } from '@/entities/header-search'

import { ProductsList } from '../product-list/products-list'
import { SearchCategories } from '../search-categories/search-categories'
import { SearchHistory } from '../search-history/search-history'
import { SearchProducts } from '../search-products/search-products'

import cl from './style.module.scss'

interface HeaderSearchContentProps {
	value: string
}

export const HeaderSearchContent = (props: HeaderSearchContentProps) => {
	const { value } = props
	const { withSalt } = useCurrentPath()

	const { history, tips, products, categories } = useHeaderSearch(value)

	const SHOW_CATS = categories.length > 0
	const SHOW_PRODUCTS = products.length > 0
	const SHOW_TIPS = tips.length > 0
	const SHOW_HISTORY = history.length > 0
	const link = value ? `/catalog/products/${encodeURIComponent(value)}?${withSalt}` : ''
	return (
		<div className={cl.main}>
			<div className={cl.cats}>
				{SHOW_HISTORY && <SearchHistory items={history} />}
				{SHOW_TIPS && <SearchProducts items={tips} />}
				{SHOW_CATS && <SearchCategories items={categories} />}
			</div>
			{SHOW_PRODUCTS && <ProductsList items={products} link={link} />}
		</div>
	)
}
